/* eslint-disable no-unused-vars */
// react
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
// components
import UploadFile from '../components/uploadFile';
// apis & store & utils
import { Modal, Input, message, Tooltip, Typography, Button, Spin, Rate } from 'antd';
import { getBookingDetail, recordIsEnterLiveRoom, getReportUrl } from '../api/request';
import { getValue, getEnv, parseUrl } from '../utils';
import QuestionModal from './booking/questionModal';
// assets
import '../assets/css/bookingDetail.less';
import selectedSad from '../assets/images/selected_sad.png';
import selectedHappy from '../assets/images/selected_happy.png';
import selectedSatisfy from '../assets/images/selected_satisfy.png';
import cryImg from '../assets/images/status-cry.png';
import { QuestionCircleOutlined, EditOutlined, LoadingOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import './subscribeRecord/personalEvaluate.less';
import { cry, kulian, xiaolian, cryActive, kulianActive, xiaolianActive } from './subscribeRecord/personalEvaluate';

const BEFORE_ClASS = {
    tipMsg: '您可提前15分钟进入直播间做准备',
    tipContent: '未到上课时间, 不可进入教室, 您可距离上课前15分钟进入教室哦',
};

const AFTER_ClASS = {
    tipMsg: '您迟到了15分钟, 无法进入教室',
    tipContent: '为了给所有学员提供更好课程服务，同时避免影响下面的服务，因此超过15分钟未进入到教室，视为放弃该私教直播服务，如有疑问，请联系您的老师，谢谢',
};

const FLAG_CONFIG = {
    CLASSNAME: 'classRoom',
    PLAYBACK: 'playback'
};

const BookingDetail = (props) => {
    const { evaluationReportId, projectId, teamType, sourcesType, sourcesId } = parseUrl();
    const editUrlAddNeed = (url) => {
        let resUrl = url;
        // 新类型拼接参数
        if (projectId) {
            resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}projectId=${projectId}`;
        }
        if (teamType) {
            resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}teamType=${teamType}`;
        }
        if (sourcesType) {
            resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}sourcesType=${sourcesType}`;
        }
        if (sourcesId) {
            resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}sourcesId=${sourcesId}`;
        }
        return resUrl;
    };

    // 打开测评
    const openReportUrl = async (id) => {
        const { data: { status, result } } = await getReportUrl({
            paperDataLogId: id,
            source: 0
        });
        if (status === 0) {
            window.open(result);
        }
    };


    const [bookingDetail, setBookingDetail] = useState({});
    const [imageList, setImageList] = useState([]);
    const [modifyModalShow, setModifyModalShow] = useState(false);

    // 问题描述
    const [question, setQuestion] = useState('');

    // 问题描述错误
    const [questionError, setQuestionError] = useState(false);

    // 文件相关
    const [fileList, setFileList] = useState([]);

    // 文件相关
    const [fileUrlListStrError, setFileUrlListStrError] = useState(false);
    // 文件相关
    const [loading, setLoading] = useState(false);
    //问题描述范例
    const [questionDemoVisible, setQuestionDemoVisible] = useState(false);

    const { TextArea } = Input;
    const [bookingType, setBookingType] = useState(0);
    //过滤预约状态0:待上课1:待评价2:已结束3:已取消
    const filterBookingType = (item) => {
        window.console.log(item.status);
        switch (item.status) {
            case 0:
                setBookingType(0);
                break;
            case 1:
                if (item.isLike) {
                    setBookingType(2);
                } else {
                    setBookingType(1);
                }

                break;
            case 2:
                if (item.isLike) {
                    setBookingType(2);
                } else {
                    setBookingType(1);
                }
                break;
            case 3:
                setBookingType(3);
                break;
            case 4:
                setBookingType(3);
                break;
            default:
                return false;

        }

    };
    const bookingWay = {
        100529221: '电话',
        100529222: '直播',
        100529223: '面授'
    };
    /**
     * @description 存储文件列表URL
     * @param {*} val
     */
    const handleSetFileUrlListStr = (val) => {
        //setFileUrlListStr(val);
        //console.log(val);
        props.editPicChange(val);
        // 如果有文件 则关闭error
        if (val) {
            setFileUrlListStrError(false);
        }
    };

    /**
     * @description 存储文件列表
     * @param {*} files
     */
    const handleSetFileList = (files) => {
        setFileList(files);
    };

    const handleModifyQuestion = async () => {
        // 表单校验
        if (!question) {
            setQuestionError(true);
            return;
        }
        if (fileList.length === 0) {
            setFileUrlListStrError(true);
            return;
        }
    };

    /**
     * @description 获取booking详情
     */
    const _getBookingInfo = async () => {
        setLoading(true);
        const params = {
            id: props.bookingDetailId,
            cancel: props.type === '3' ? 1 : 0
        };
        const { data } = await getBookingDetail(params);
        if (!data.status) {
            const bookingDetailInfo = getValue(() => data.result);
            setBookingDetail(bookingDetailInfo);
            // 设置图片列表 & 上传文件列表
            if (bookingDetailInfo.memberImage) {
                const imageListArr = bookingDetailInfo.memberImage.split(',');
                const fileListArr = [];
                setImageList(imageListArr);
                imageListArr.forEach((item, key) => {
                    let obj = {
                        uid: key,
                        url: '//' + getEnv() + 'simg01.gaodunwangxiao.com/' + item,
                        name: item.split('/').pop()
                    };
                    fileListArr.push(obj);
                });
                setFileList(fileListArr);
            }
            filterBookingType(bookingDetailInfo);
            // 设置问题描述
            setQuestion(bookingDetailInfo.description);
            // timeRange supportCancel 传递给父组件
            props.parentSetTimeRange(bookingDetailInfo.timeRange);
            props.parentSetSupportCancel(bookingDetailInfo.supportCancel);
        } else {
            message.warning(data.message || data.info);
        }
        setLoading(false);
    };


    /**
     * @description 进入教室 | 查看回放跳转
     * @param {*} type 功能类型
     * @param {*} data 详情数据
     */
    const handleJumpUrl = (type, {
        customerId,
        enterStudioUuid,
        enterStudioPath,
        enterPlaybackPath
    }) => {
        if (type === FLAG_CONFIG.CLASSNAME) {
            recordIsEnterLiveRoom({
                processId: customerId,
                uuid: enterStudioUuid
            }).then(res => {
                res.data.result && window.open(enterStudioPath);
            });
        } else {
            enterPlaybackPath && window.open(enterPlaybackPath);
        }
    };
    //反馈报告
    const handelFeedBack = ({
        customerId,
        commit
    }) => {
        if (!(1 == commit)) {
            message.warning('请耐心等待老师提交反馈');
            return;
        }
        props.history.push(editUrlAddNeed(`/tutor/feedback?processId=${customerId}`));
    };
    //编辑按钮点击
    const editClick = () => {
        if (props.detailMode === 1) {
            return;
        }
        props.editPicChange && props.editPicChange(bookingDetail.memberImage);
        props.editContextChange && props.editContextChange(bookingDetail.evaluationPath ? bookingDetail.remark : bookingDetail.description);
        props.changeMode && props.changeMode(1, bookingDetail.evaluationPath ? 1 : 0);
        // 设置图片列表 & 上传文件列表
        if (bookingDetail.memberImage) {
            const imageListArr = bookingDetail.memberImage.split(',');
            const fileListArr = [];
            setImageList(imageListArr);
            imageListArr.forEach((item, key) => {
                let obj = {
                    uid: key,
                    url: '//' + getEnv() + 'simg01.gaodunwangxiao.com/' + item,
                    name: item.split('/').pop()
                };
                fileListArr.push(obj);
            });
            setFileList(fileListArr);
        } else {
            setFileList([]);
        }
    };
    /**
     * @description 生命周期 api请求
     */
    useEffect(() => {
        _getBookingInfo();
    }, []);

    const EvaluateEvaluation = (
        <div className="detail-form evaluation-result">
            <div className="detail-row clear">
                <div className="suggest-title">满意程度</div>
                {
                    +bookingDetail.isLike !== 4 && (
                        <div className="main-evaluate">
                            <div className="evaluate">
                                <li>
                                    <img src={+bookingDetail.isLike === 5 ? kulianActive : kulian} />
                                    <p className={+bookingDetail.isLike === 5 ? 'active' : ''}>差评</p>
                                </li>
                                <li>
                                    <img src={+bookingDetail.isLike === 6 ? cryActive : cry} />
                                    <p className={+bookingDetail.isLike === 6 ? 'active' : ''}>一般</p>
                                </li>
                                <li>
                                    <img src={+bookingDetail.isLike === 3 ? xiaolianActive : xiaolian} />
                                    <p className={+bookingDetail.isLike === 3 ? 'active' : ''}>满意</p>
                                </li>
                            </div>
                        </div>
                    )
                }

                <div className="evaluate-star">
                    <li>
                        <span>内容价值</span><Rate
                            disabled
                            value={+bookingDetail.contentValue} />
                        {/* <a>{arrySatisfy[+bookingDetail.contentValue - 1]}</a> */}
                    </li>
                    <li>
                        <span>教学态度</span><Rate
                            disabled
                            value={+bookingDetail.teachingAttitude} />
                        {/* <a>{arrySatisfy[+bookingDetail.teachingAttitude - 1]}</a> */}
                    </li>
                    <li>
                        <span>网络质量</span><Rate
                            disabled
                            value={+bookingDetail.networkQuality} />
                        {/* <a>{arrySatisfy[+bookingDetail.networkQuality - 1]}</a> */}
                    </li>
                </div>
            </div>
            <div className="detail-row clear">
                <div className="suggest-title">服务建议</div>
                <div className="suggest-main">{bookingDetail.studentComment}</div>
            </div>
        </div>
    );
    const NoEvaluateEvaluation = (
        <div className="detail-form">
            <div className="detail-row clear">
                <div className="row-label fl">满意程度：</div>
                {
                    bookingDetail.isLike && (
                        <div className="row-content fr">
                            <div className="like-container">
                                <img
                                    className="like-img"
                                    src={bookingDetail.isLike === 2 ? selectedSad : bookingDetail.isLike === 3 ? selectedHappy : selectedSatisfy} />
                                <div className={bookingDetail.isLike === 2 ? 'like-content sad' : bookingDetail.isLike === 3 ? 'like-content happy' : 'like-content satisfy'}>{bookingDetail.isLike === 2 ? '不满意' : bookingDetail.isLike === 3 ? '满意' : '非常满意'}</div>
                            </div>
                        </div>
                    )
                }
            </div>
            <div className="detail-row clear">
                <div className="row-label fl">服务建议：</div>
                <div className="row-content fr">{bookingDetail.studentComment}</div>
            </div>
        </div>
    );
    const noEvaluate = (
        <div className="to-appraise-wrapper">
            <img
                className="cry-appraise-img"
                src={cryImg} />
            <div className="text-wrapper">
                <div>
                    您还未评价
                </div>
                <div>
                    快来对课程进行评价吧！
                </div>
                <Button
                    onClick={() => props.gotoEvaluation && props.gotoEvaluation()}
                    type="link"
                >
                    立即评价
                </Button>
            </div>
        </div>
    );
    const BookingPreDetail = (
        <div>
            {
                props.type === '2' && (
                    <>
                        {
                            evaluationReportId ? bookingDetail.contentValue ? EvaluateEvaluation : noEvaluate : bookingDetail.isLike ? NoEvaluateEvaluation : noEvaluate
                        }

                    </>
                )
            }
            <div className="detail-title">我的预约服务</div>
            <div className="detail-form">
                <div className="detail-row clear">
                    <div className="row-left fl"><span>当前状态：</span><span className="detail-status">{
                        (bookingType === 0 && bookingDetail.isEnterStudio === 0) ? '上课中' : (bookingType === 0 ? '待上课' : '已结束')}</span></div>
                    <div className="row-right fl"><span>提交时间：</span><span className="detail-content">{bookingDetail.createTime}</span></div>
                </div>
                <div className="detail-row clear">
                    <div className="row-left fl"><span>上课科目：</span><span className="detail-content">{bookingDetail.subjectName}</span></div>
                    <div className="row-right fl"><span>手机号码：</span><span className="detail-content">{bookingDetail.reserveMobile}</span></div>
                </div>
                <div className="detail-row class-way clear">
                    <div className="row-left fl">
                        <span>上课方式：</span>
                        <span className="detail-content">{bookingWay[bookingDetail.serviceType]}</span>&emsp;
                        {/* 待上课 */}
                        {(bookingType === 0 && bookingWay[bookingDetail.serviceType] === '直播'
                            ? (
                                <Button
                                    disabled={bookingDetail.isEnterStudio === 0 ? false : true}
                                    onClick={() => handleJumpUrl(FLAG_CONFIG.CLASSNAME, bookingDetail)}
                                    size="small"
                                    type="primary"
                                >进入教室</Button>
                            )
                            : null)}
                        {/* 待评价 */}
                        {((bookingType === 2 || bookingType === 1) && bookingDetail.supportReport == 1
                            ? (
                                <Button
                                    className={bookingDetail.commit ? 'activeColor' : ''}
                                    disabled={bookingDetail.commit ? false : true}
                                    onClick={() => handelFeedBack(bookingDetail)}
                                    shape="round"
                                    size="small"
                                    style={{ marginRight: '10px' }}
                                >反馈报告</Button>
                            )
                            : null)}
                        {((bookingType === 2 || bookingType === 1) && bookingWay[bookingDetail.serviceType] === '直播' && bookingDetail.isSupportPlayback == 1
                            ? (
                                <Button
                                    className={bookingDetail.isPlayback ? 'activeColor' : ''}
                                    disabled={bookingDetail.isPlayback ? false : true}
                                    onClick={() => handleJumpUrl(FLAG_CONFIG.PLAYBACK, bookingDetail)}
                                    shape="round"
                                    size="small"
                                >{bookingDetail.isPlayback ? '查看回放' : '暂无回放'}</Button>
                            )
                            : null)}

                    </div>
                    <div className="row-right fl"><span>上课时间：</span><span className="detail-content">{bookingDetail.timeRange}</span></div>
                    {/* 未开始:1 | 迟到:2 */}
                    {bookingType === 0 && [1, 2].includes(bookingDetail.isEnterStudio) ? (
                        <Tooltip
                            placement="bottomLeft"
                            title={bookingDetail.isEnterStudio === 1 ? BEFORE_ClASS.tipContent : AFTER_ClASS.tipContent}
                        >
                            <span className={bookingDetail.isEnterStudio === 1 ? 'before_class' : 'after_class'}>
                                <ExclamationCircleOutlined />&nbsp;
                                <Typography.Text type="danger">{bookingDetail.isEnterStudio === 1 ? BEFORE_ClASS.tipMsg : `您迟到了${bookingDetail.lateTime}分钟, 无法进入教室`}</Typography.Text>
                            </span>
                        </Tooltip>
                    ) : null}
                </div>
                {
                    (bookingDetail.teacherId && bookingDetail.bookingType == '1') ? (
                        <div className="detail-row clear">
                            <div className="row-left fl"><span>授课老师：</span><span className="detail-content">{bookingDetail.teacherName}</span></div>
                        </div>
                    ) : null
                }

            </div>
            {
                <div className="detail-title my-question-wrapper">
                    <span>我的提问</span>
                    {
                        bookingType === 0 && props.detailMode !== 1 && !bookingDetail.evaluationPath && bookingDetail.sourcesType !== 2 && (
                            <>
                                {
                                    bookingDetail.updateQuestion === 0 && !bookingDetail.evaluationPath ? (
                                        <span
                                            className="edit-question-btn"
                                            onClick={() => editClick()}
                                        >
                                            编辑提问
                                            <EditOutlined />
                                        </span>
                                    ) : (
                                        <Tooltip title={bookingDetail.updateQuestion === 1 ? `仅可在正式上课${bookingDetail.latestBookingTime || 0}小时前进行编辑` : '编辑次数用完啦'}>
                                            <span className="edit-question-btn edit-question-btn-disabled" >
                                                编辑提问
                                                <EditOutlined />
                                            </span>
                                        </Tooltip>
                                    )
                                }

                            </>
                        )
                    }


                </div>
            }

            {
                (bookingDetail.sourcesType === 2 || bookingDetail.evaluationPath) ? (
                    <div className="evaluationReport">
                        本次私教服务，老师将根据您此次测评遇到的问题来解答&ensp;
                        {
                            bookingDetail.sourcesType === 2 ? (
                                <a
                                    className="gd-green"
                                    href="javascript:;"
                                    onClick={() => openReportUrl(bookingDetail.sourcesId)}
                                    rel="noopener noreferrer"
                                >测评报告</a>
                            ) : (
                                <a
                                    className="gd-green"
                                    href={bookingDetail.evaluationPath}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >测评报告</a>
                            )
                        }
                    </div>
                ) : null
            }
            {/* 根据是否有测评判断测评*/}
            {
                (bookingDetail.sourcesType !== 2 && !bookingDetail.evaluationPath) && (
                    props.detailMode === 1 ? (
                        <div style={{ marginTop: '20px' }}>
                            <div className="detail-row clear">
                                <div className="item-label fl">
                                    <QuestionCircleOutlined
                                        onClick={() => setQuestionDemoVisible(true)}
                                        style={{ marginRight: '2px' }} />
                                    问题描述：
                                </div>
                                <TextArea
                                    className="fl"
                                    maxLength={200}
                                    onChange={e => { props.editContextChange(e.target.value); }}
                                    placeholder="为了让老师可以以后更好地为您服务，建议同学能留下宝贵的建议"
                                    rows={4}
                                    style={{ width: 354 }}
                                    value={props.editContext} />
                            </div>
                            <div
                                className="detail-row clear"
                                style={{ marginTop: '20px' }}
                            >
                                <div className="row-label fl">上传图片：</div>
                                <div
                                    className="row-upload fl"
                                    style={{ width: '350px' }}
                                >
                                    <UploadFile
                                        fileList={fileList}
                                        parentFileList={handleSetFileList.bind(this)}
                                        parentFileUrlListStr={handleSetFileUrlListStr.bind(this)} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="detail-form">
                            <div className="detail-row clear">
                                <div className="row-label fl">问题描述：</div>
                                <div className="row-content fl">{bookingDetail.description}</div>
                            </div>
                            <ul className="img-group">
                                {
                                    imageList.length > 0 && imageList.map((image, key) => (
                                        <img
                                            alt="question"
                                            key={key}
                                            src={'//' + getEnv() + 'simg01.gaodunwangxiao.com/' + image} />
                                    ))
                                }
                            </ul>
                        </div>
                    )
                )
            }
        </div >
    );

    const BookingCancelDetail = (
        <div>
            <div className="detail-title">我的预约</div>
            <div className="detail-form">
                <div className="detail-row clear">
                    <div className="row-left fl"><span>当前状态：</span><span className="detail-status-cancel">已取消</span></div>
                    <div className="row-right fl"><span>提交时间：</span><span className="detail-content">{bookingDetail.createTime}</span></div>
                </div>
                <div className="detail-row clear">
                    <div className="row-left fl"><span>取消时间：</span><span className="detail-content">{bookingDetail.updateAt}</span></div>
                    <div className="row-right fl"><span>返还次数：</span><span className="detail-content">{bookingDetail.status === 4 ? '1次' : '0次'}</span></div>
                </div>
                <div className="detail-row clear">
                    <div className="row-left fl"><span>上课科目：</span><span className="detail-content">{bookingDetail.subjectName}</span></div>
                    <div className="row-right fl"><span>手机号码：</span><span className="detail-content">{bookingDetail.reserveMobile}</span></div>
                </div>
                <div className="detail-row clear">
                    <div className="row-left fl"><span>上课方式：</span><span className="detail-content">{bookingWay[bookingDetail.serviceType]}</span></div>
                    <div className="row-right fl"><span>上课时间：</span><span className="detail-content">{bookingDetail.timeRange}</span></div>
                </div>
                {
                    (bookingDetail.teacherId && bookingDetail.bookingType == '1') ? (
                        <div className="detail-row clear">
                            <div className="row-left fl"><span>授课老师：</span><span className="detail-content">{bookingDetail.teacherName}</span></div>
                        </div>
                    ) : null
                }
            </div>
            <div className="detail-title">我的提问</div>
            {
                (bookingDetail.sourcesType === 2 || bookingDetail.evaluationPath) ? (
                    <div className="evaluationReport">
                        本次私教服务，老师将根据您此次测评遇到的问题来解答&ensp;
                        {
                            bookingDetail.sourcesType === 2 ? (
                                <a
                                    className="gd-green"
                                    href="javascript:;"
                                    onClick={() => openReportUrl(bookingDetail.sourcesId)}
                                    rel="noopener noreferrer"
                                >测评报告</a>
                            ) : (
                                <a
                                    className="gd-green"
                                    href={bookingDetail.evaluationPath}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >测评报告</a>
                            )
                        }

                    </div>
                ) : null
            }
            {
                (bookingDetail.sourcesType !== 2 && !bookingDetail.evaluationPath) && (
                    <div className="detail-form">
                        <div className="detail-row clear">
                            <div className="row-label fl">问题描述：</div>
                            <div className="row-content fr">{bookingDetail.evaluationPath ? bookingDetail.remark : bookingDetail.description}</div>
                        </div>
                        <ul className="img-group">
                            {
                                imageList.length > 0 && imageList.map((image, key) => (
                                    <img
                                        alt="question"
                                        key={key}
                                        src={'//' + getEnv() + 'simg01.gaodunwangxiao.com/' + image} />
                                ))
                            }
                        </ul>
                    </div>
                )
            }
        </div>
    );

    const BookingDetailContainer = () => {
        filterBookingType(bookingDetail);
        if (bookingType === 3) {
            return BookingCancelDetail;
        } else {
            return BookingPreDetail;
        }
    };

    const ModifyModal = (
        <Modal
            cancelText="取消"
            okText="确定"
            onCancel={() => setModifyModalShow(false)}
            onOk={() => handleModifyQuestion()}
            title="修改问题"
            visible={modifyModalShow}
        >
            <div className="detail-row clear">
                <div className="row-label fl">问题描述：</div>
                <TextArea
                    className="fl"
                    maxLength={200}
                    onChange={e => { setQuestion(e.target.value); setQuestionError(false); }}
                    placeholder="为了让老师可以更好地为您服务，建议同学提前写下问题以及学习情况"
                    rows={4}
                    style={{ width: 354 }}
                    value={question} />
            </div>
            <div className="row-error">{questionError && '请输入您的问题'}</div>
            <div className="detail-row clear">
                <div className="row-label fl">上传图片：</div>
                <div className="row-upload fl">
                    <UploadFile
                        fileList={fileList}
                        parentFileList={handleSetFileList.bind(this)}
                        parentFileUrlListStr={handleSetFileUrlListStr.bind(this)} />
                </div>
            </div>
            <div className="row-error">{fileUrlListStrError && '请上传图片'}</div>
        </Modal>
    );
    const onChangeModal = () => {
        setQuestionDemoVisible(false);
    };
    // eslint-disable-next-line valid-jsdoc
    /**
 * @description item
 */
    return (
        <Spin spinning={loading}>
            {Object.keys(bookingDetail).length > 0 ?
                bookingType === 3 ?
                    BookingCancelDetail :
                    BookingPreDetail : <div align="center"><LoadingOutlined /></div>}
            {/* 修改问题弹窗 */}
            {ModifyModal}
            <QuestionModal
                keyValue={2}
                onChangeModal={() => onChangeModal()}
                questionDemoVisible={questionDemoVisible} />
        </Spin>
    );
};

export default withRouter(BookingDetail);